<template>
    <div class="d-inline position-relative">
        <div v-if="show"
             @keydown.esc="close"
             class="modal fade bd-example-modal-lg show"
             tabindex="-1"
             role="dialog"
             style="display: block;">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{$t('contact.header')}}
                        </h5>

                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                            <span aria-hidden="true"><i class="fa fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-danger" v-if="this.errors.hasOwnProperty('throttled')">
                            {{$t('general.throttled')}}
                        </div>
                        <div class="alert alert-danger" v-if="this.errors.hasOwnProperty('server_error')">
                            {{$t('general.server_error')}}
                        </div>
                        <div v-if="success">
                            <div class="alert alert-success">
                                {{$t('contact.success')}}
                            </div>
                            <button @click="close" class="btn btn-primary btn-block">
                                {{$t('general.close')}}
                            </button>
                        </div>
                        <form v-else method="post" :action="action" @submit="submit">
                            <div class="form-group">
                                <label>{{$t('general.your_email')}}</label>
                                <input
                                        required
                                        type="email"
                                        name="email"
                                        class="form-control"
                                        :class="{'is-invalid': this.errors.hasOwnProperty('email')}"
                                        :placeholder="$t('general.your_email')" v-model="email"
                                >
                                <span v-if="this.errors.hasOwnProperty('email')" class="invalid-feedback" role="alert">
                                    <strong v-for="message in this.errors.email">{{ message }}</strong>
                                </span>
                            </div>
                            <div class="form-group">
                                <label>{{$t('general.subject')}}</label>
                                <input
                                        required
                                        type="text"
                                        name="subject"
                                        class="form-control"
                                        :class="{'is-invalid': this.errors.hasOwnProperty('subject')}"
                                        :placeholder="$t('general.subject')" v-model="subject"
                                >
                                <span v-if="this.errors.hasOwnProperty('subject')" class="invalid-feedback"
                                      role="alert">
                                    <strong v-for="message in this.errors.subject">{{ message }}</strong>
                                </span>
                            </div>
                            <div class="form-group">
                                <label>{{$t('general.message')}}</label>
                                <textarea
                                        required
                                        name="message"
                                        class="form-control"
                                        rows="3"
                                        v-model="message"
                                        :class="{'is-invalid': this.errors.hasOwnProperty('message')}"
                                ></textarea>
                                <span v-if="this.errors.hasOwnProperty('message')" class="invalid-feedback"
                                      role="alert">
                                    <strong v-for="message in this.errors.message">{{ message }}</strong>
                                </span>
                            </div>
                            <button type="submit" class="btn btn-success" :disabled="loading">
                                {{$t('general.send')}}
                            </button>
                        </form>
                    </div>
                    <LoadingOverlay v-if="show && loading" class="position-absolute"></LoadingOverlay>
                </div>
            </div>
        </div>
        <div v-if="show" class="modal-backdrop fade show" @click="close"></div>
    </div>
</template>
<style scoped lang="scss">
    .modal {
        pointer-events: none;

        .modal-body {
            max-height: 80vh;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }
</style>
<script>

    import axios from 'axios';
    import bus from '../lib/Bus';
    import LoadingOverlay from "./LoadingOverlay";

    export default {
        name      : "ContactModal",
        components: {
            LoadingOverlay,
        },
        props     : {
            emailDefault: {
                type   : String,
                default: null,
            },
            masterid    : {
                type   : Number,
                default: null,
            },
            showid    : {
                type   : Number,
                default: null,
            }
        },
        data() {
            return {
                errors : {},
                action : '/signup/contact',
                email  : this.emailDefault,
                subject: null,
                message: null,
                loading: false,
                show   : false,
                success: false,
            };
        },
        mounted() {
            bus.$on('contact.open', this.open);
        },
        methods   : {
            close() {
                if (this.success) {
                    this.email   = null;
                    this.subject = null;
                    this.message = null;
                }
                this.show    = false;
                this.success = false;
                this.loading = false;
            },
            open() {
                this.show = true;
            },
            submit(e) {
                e.preventDefault();
                if (this.loading) {
                    return;
                }
                this.errors  = {};
                this.loading = true;
                axios
                    .post(this.action, {
                        email   : this.email,
                        subject : this.subject,
                        message : this.message,
                        masterid: this.masterid,
                        showid  : this.showid,
                    })
                    .then(() => {
                        this.loading = false;
                        this.success = true;
                    })
                    .catch((err) => {

                        this.loading = false;

                        if (err.response.status === 429) {
                            this.errors = {
                                throttled: true,
                            }
                        } else if (err.response.status === 500) {
                            this.errors = {
                                server_error: true,
                            }
                        } else if (err.response && err.response.data) {
                            if (err.response.data.errors) {
                                this.errors = err.response.data.errors;
                            }
                        }
                    })
                ;
            }
        }
    }
</script>
